import { API_PRICE_LIST, API_SCHEDULE } from "./constants/api";

export function scheduleUrlWithDates(dateFrom, dateTo) {
  return `${API_SCHEDULE}/Available_List?DateFrom=${dateFrom}&DatetTo=${dateTo}`;
}

export function getPriceListURL(date) {
  return `${API_PRICE_LIST}?date=${date}`;
}